import AutoDepositSection from 'pages/profile/components/ProfileTabContent/Bank&Transfers/components/AutoDepositSection';
import BankStateSection from 'pages/profile/components/ProfileTabContent/Bank&Transfers/components/BankStateSection';
import TotalCashSection from 'pages/profile/components/ProfileTabContent/Bank&Transfers/components/TotalCashSection';
import useUserDetails from '../../../../../hooks/requests/user/hooks/useUserDetails';

const BankAndTransfers = () => {
  const { isTenant } = useUserDetails();
  return (
    <>
      <BankStateSection />
      {!isTenant && (
        <>
          <TotalCashSection />
          <AutoDepositSection />
        </>
      )}
    </>
  );
};

export default BankAndTransfers;
